var _rect, _path, _rect2, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 13,
    fill: "#201E26"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1193 11.6362H21.7343C20.891 11.6419 20.0904 11.2611 19.5561 10.6003L18.4414 9.0362C17.9159 8.36961 17.1153 7.98709 16.2733 8.00033H13.8803C9.58513 8.00033 8.00001 10.5589 8.00001 14.9095V19.6124C7.99467 20.1295 30.9981 20.1289 30.9996 19.6124V18.245C31.0201 13.8944 29.4758 11.6362 25.1193 11.6362Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11.2928,
    width: 23.8635,
    height: 20.3281,
    rx: 6,
    fill: "#8146FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8573 16.0999H15.5926C14.4961 16.0999 13.6073 17.0079 13.6073 18.1279V24.2119C13.6073 25.332 14.4961 26.2399 15.5926 26.2399H24.8573C25.9537 26.2399 26.8426 25.332 26.8426 24.2119V18.1279C26.8426 17.0079 25.9537 16.0999 24.8573 16.0999Z",
    fill: "#343843"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.028 27.7999H17.4225C17.2957 27.7999 17.1712 27.7711 17.0624 27.7165C16.9536 27.6619 16.8645 27.5836 16.8047 27.4899C16.7449 27.3962 16.7165 27.2907 16.7226 27.1845C16.7288 27.0784 16.7692 26.9757 16.8395 26.8873L19.6423 23.365C19.71 23.2889 19.7979 23.2272 19.8991 23.1846C20.0003 23.1421 20.112 23.1199 20.2253 23.1199C20.3385 23.1199 20.4502 23.1421 20.5514 23.1846C20.6526 23.2272 20.7406 23.2889 20.8082 23.365L23.611 26.8873C23.6814 26.9757 23.7218 27.0784 23.7279 27.1845C23.734 27.2907 23.7056 27.3962 23.6458 27.4899C23.586 27.5836 23.4969 27.6619 23.3881 27.7165C23.2793 27.7711 23.1548 27.7999 23.028 27.7999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon4);
export default __webpack_public_path__ + "static/media/group_icon4.c648d187f096b6e98e9b6d48d1a9c845.svg";
export { ForwardRef as ReactComponent };